export const LockedPackagingIconStyles = {
  image: {
    marginLeft: '3px',
    marginBottom: '2px',
  },
};
